import { Text } from "../ui/text";

const StatusTag = ({ status }: { status: "complete" | "progress" }) => {
  return (
    <div>
      {status === "complete" && (
        <div className="flex items-center gap-[7px] px-[12px] py-[4px] rounded-[16px] bg-[#C5F7EE] text-[#027167]">
          <div className="w-2 h-2 rounded-full bg-[#18988B] animate-pulse" />
          <Text variant="label-md" className="text-inherit">
            완료
          </Text>
        </div>
      )}
      {status === "progress" && (
        <div className="flex items-center gap-[7px] px-[12px] py-[4px] rounded-[16px] bg-blue-100 text-[#276DF4]">
          <div className="w-2 h-2 rounded-full bg-[#276DF4] animate-pulse" />
          <Text variant="label-md" className="text-inherit">
            진행중
          </Text>
        </div>
      )}
    </div>
  );
};

export default StatusTag;
